<template>
  <div>
    <chartLoaders v-if="showLoaders == true"></chartLoaders>
    <screen-loader v-if="showLoaders == true"></screen-loader>
    <div v-else-if="timeoutMessage != ''" class="tabs-no-test-div timeout">
      <div class="text-center">
        {{ timeoutMessage }}
        <v-icon flat @click="loadItems()" color="blue-darken-3" icon="mdi-reload" size="large"></v-icon>
      </div>
    </div>
    <v-card-text class="chart-table-wrap pa-0" v-else-if="serverItems.length > 0 && showLoaders == false">
      <!-- <v-select
        v-model="selectedSort"
        label="Sort Step Pressure"
        :items="sortOptions"
        @update:modelValue="onSelectSort"
      >
      </v-select> -->
      <div class="chart-wrap" v-if="hasStepPressure">
        <div v-for="(variable, index) in variables" :key="index" class="chart-column sep-test-chart-column">
          <div class="modal-tab-div">
            <div class="tab-div">
              <p>Y Axis Scale:</p>
              <v-btn-toggle v-model="isYLog[variable]" class="axis-toggle setHeight" mandatory
                @update:modelValue="handleYScaleToggleChange(variable)">
                <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
              </v-btn-toggle>
            </div>
          </div>
          <ChartTitleTooltip :title="getChartTitle(variable)" />
          <div :ref="`chart-${index}`" class="main-chart">
          </div>

          <v-dialog v-model="isPreviewOpen[index]" class="multi-chart-preview-div dashboard-chart-preview composition">
            <v-card class="position-relative studio-card">
              <v-card-text>
                <div class="popup-top">
                  <div class="modal-tab-div">
                    <div class="tab-div">
                      <p>Y Axis Scale:</p>
                      <v-btn-toggle v-model="isModalYLog[index]" class="axis-toggle setHeight" mandatory
                        @update:modelValue="handleModalYScaleToggleChange(index)">
                        <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                        <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                      </v-btn-toggle>
                    </div>
                  </div>
                  <ChartTitleTooltip :title="getChartTitle(variable)" extra-class="w-100" />
                  <!-- <img :src="cross" alt="cross" @click="closeModal(index)" class="chart-preview-close-btn"> -->
                </div>
                <div :ref="`modal-chart-${index}`" class="modal-chart-container"></div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
      <div v-else-if="!hasStepPressure" class="text-center pt-3 pb-5">
        <h4>Charts couldn't be plotted as step pressure is not available in this test.</h4>
      </div>
      <div class="table-wrap">
        <div class="table-title-div" v-if="serverItems.length > 0">
          <p class="table-title">Multi Stage Separator Test</p>
          <div class="csv-btn" @click="downloadTableCSV">
            <v-img class="pointer" :src="documentDownload" alt="csv download"></v-img>
          </div>
        </div>
        <v-data-table :headers="headers" :items="serverItems" :total-items="totalItems" :items-per-page="itemsPerPage"
          :loading="loading" :search="search" :item-value="name" virtual-items fixed-header
          max-height="calc(100vh - 380px)">
          <template v-slot:headers>
            <tr class="main-header">
              <th v-for="(header, index) in headers" :key="index" class="sticky-header">
                {{ header.name }}
                <span @click="handleHeaderClick(header.key)">
                  <span v-if="header.key === 'stepPressure'">
                    <v-icon v-if="sortOrder === 'asc'" @click.stop="sortStepPressure('desc')"
                      small>mdi-arrow-down</v-icon>
                    <v-icon v-else @click.stop="sortStepPressure('asc')" small>mdi-arrow-up</v-icon>
                  </span>
                </span>
              </th>
            </tr>
            <tr class="sub-header">
              <th v-for="(header, index) in headers" :key="index">
                {{ header.unit }}
              </th>
            </tr>
          </template>
          <template v-slot:body="{ items }">
            <tr v-for="(item, index) in items" :key="index">
              <td v-for="(header, headerIndex) in headers" :key="headerIndex">
                <template v-if="header.key === 'saturationPressure'">
                  <template v-if="index === 0">{{ displayValue(header.key, item[header.key]) }}</template>
                  <template v-else>-</template>
                </template>
                <template v-else>
                  {{ displayValue(header.key, item[header.key]) !== null ? displayValue(header.key, item[header.key]) :
                    '-'
                  }}
                </template>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card-text>
    <div v-else-if="(!serverItems || serverItems.length === 0) && showLoaders == false" class="tabs-no-test-div">
      <h4>No data available.</h4>
    </div>
  </div>
</template>

<script>
import Plotly from "plotly.js-dist-min";
import ChartLoaders from "../Loaders/ChartLoaders.vue";
import ScreenLoader from "../Loaders/ScreenLoader.vue";
import ChartTitleTooltip from "../DifferentialLiberation/Charts/ChartTitleTooltip.vue";
import { getDisplayName, getSortOrder } from '../../../utils/cache';
import api from "../../../axiosInterceptor";

import downloadIcon from '../../../assets/Svg/Chart/csv_chart.svg';
import camIcon from '../../../assets/Svg/camIcon.svg';
import Expand from "../../../assets/Svg/Chart/expand-btn.svg";
import { mapGetters } from "vuex";
import { chartGridColor } from "@/utils/chartTheme";
import { downloadPlotlyAsPng } from "@/utils/plotlyPngDownload";
import {
  applyScatterModalYAxisScale,
  buildSimpleScatterLogYAxisConfig,
} from "@/utils/plotlyLogAxis";
import { buildVerticalYAxisTitle } from "@/utils/chartAxisUtils";

export default {
  name: "SeparatorTestData",
  components: {
    ChartLoaders,
    ScreenLoader,
    ChartTitleTooltip,
  },
  data: () => ({
    showLoaders: true,
    documentDownload: require("../../../assets/Images/csv.svg"),
    cross: require("../../../assets/Svg/Chart/chart-cross.svg"),
    itemsPerPage: 0,
    headers: [],
    serverItems: [],
    loading: true,
    totalItems: 0,
    variables: ["1", "2"],
    isPreviewOpen: Array().fill(false),
    chartData: Array().fill(null),
    cachedData: {},
    testID: "",
    testName: "",
    sampleID: "",
    fluidSampleID: "",
    hasStepPressure: false,
    saturationPressure: "",
    saturationPressure_UOM: "",
    testTemperature: "",
    testTemperature_UOM: "",
    sortOrder: 'desc',
    timeoutMessage: "",
    yAxisScales: {},
    isYLog: {},
    modalYAxisScales: {},
    isModalYLog: {},
    sepTestHeaders: {}
  }),
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
  },
  methods: {

    handleYScaleToggleChange(variable) {
      if (this.yAxisScales[variable] === undefined) {
        this.yAxisScales[variable] = 'linear';
      }

      this.yAxisScales[variable] = this.isYLog[variable] ? "log" : "linear";

      const chartIndex = this.variables.indexOf(variable);

      this.modalYAxisScales[chartIndex] = this.yAxisScales[variable];
      if (this.modalYAxisScales[chartIndex] === "log") {
        this.isModalYLog[chartIndex] = true;
      }
      else {
        this.isModalYLog[chartIndex] = false;
      }
      if (this.cachedSeparatorTest) {
        this.plotChartForVariable(variable, chartIndex, this.cachedSeparatorTest);
      }
    },
    handleModalYScaleToggleChange(index) {
      if (this.modalYAxisScales[index] === undefined) {
        this.modalYAxisScales[index] = 'linear';
      }

      this.modalYAxisScales[index] = this.isModalYLog[index] ? "log" : "linear";

      this.plotModalChart(index)
    },
    sortStepPressure(order) {
      this.sortOrder = order;
      if (order === 'asc') {
        this.serverItems.sort((a, b) => a.stepPressure - b.stepPressure);
      } else {
        this.serverItems.sort((a, b) => b.stepPressure - a.stepPressure);
      }
    },
    downloadChartCSV(index) {
      const chartData = this.chartData[index];
      const variable = this.variables[index];

      if (chartData) {
        const yTitle = this.getHeaderDisplayName(variable);
        const xTitle = chartData.layout.xaxis.title;
        const xTitleText = typeof xTitle === "string" ? xTitle : xTitle?.text || "Pressure (psia)";
        const fileName = `${yTitle} vs ${xTitleText} data.csv`;

        const csvHeader = [xTitleText, yTitle];

        const csvRows = chartData.trace.x.map((xValue, i) => [xValue, chartData.trace.y[i]]);

        const csvContent = [csvHeader.join(','), ...csvRows.map(row => row.join(','))].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

        const link = document.createElement('a');
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error('Your browser does not support downloading files programmatically. Please try a different browser.');
        }
      }
    },

    downloadTableCSV() {
      if (this.serverItems && this.serverItems.length > 0) {
        const fileName = `Multistage_separator.csv`;

        const csvHeader = this.headers.map((header) => header.name);
        const csvUnits = this.headers.map((header) => header.unit);

        const csvRows = this.serverItems.map((item) =>
          this.headers.map((header) => item[header.key])
        );

        const csvContent = [
          csvHeader.join(","),
          csvUnits.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error(
            "Your browser does not support downloading files programmatically. Please try a different browser."
          );
        }
      } else {
        console.error("No data available in the table to download.");
      }
    },

    async loadItems() {
      var sampleId = this.$route.params.sampleId;
      var separatorId = this.$route.params.id;
      this.loading = true;
      this.showLoaders = true;
      this.timeoutMessage = "";

      try {
        let response = await api.get(
          `public/api/samples/${sampleId}/separatortests/${separatorId}`
        );
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          this.cachedSeparatorTest = response.data.data.separatortest;
          this.serverItems = response.data.data.separatortest && response.data.data.separatortest.separatorTestSteps ? response.data.data.separatortest.separatorTestSteps : [];
          this.totalItems = response.data.data.separatortest && response.data.data.separatortest.length ? response.data.data.separatortest.length : 0;
          this.sepTestHeaders = response.data.data.pageData.separatorTestHeader;
          this.sendDataToParent();

          const sortByKeys = await getSortOrder("separatortests", "separatorTest", "table_for_oil");
          const sortByKeysGas = await getSortOrder("separatortests", "separatorTest", "table_for_gas");

          this.hasStepPressure = this.serverItems.some(item => item.hasOwnProperty('stepPressure'));

          const availableKeysOil = new Set(
            Array.isArray(sortByKeys) ? sortByKeys.filter((key) =>
              this.serverItems.some((item) => key in item)
            ) : []
          );

          const allKeysOil = Array.isArray(sortByKeys) ? sortByKeys.filter((key) => availableKeysOil.has(key)) : [];

          const availableKeysGas = new Set(
            Array.isArray(sortByKeysGas) ? sortByKeysGas.filter((key) =>
              this.serverItems.some((item) => key in item)
            ) : []
          );

          const allKeysGas = Array.isArray(sortByKeysGas) ? sortByKeysGas.filter((key) => availableKeysGas.has(key)) : [];

          const allKeysGasFilter = allKeysGas.filter(key => key !== 'stepPressure' && key !== 'stepTemperature' && key !== "saturationPressure" && key !== 'stepNumber');

          const allKeys = [...allKeysOil, ...allKeysGasFilter];

          this.variables = Array.from(allKeys).filter(key => key !== 'stepPressure' && key !== 'stepTemperature' && key !== 'saturationPressure' && key !== 'stepNumber');

          const allUniqueKeys = Array.from(allKeys);

          const displayNames = [];
          const digitsArray = [];
          await Promise.all(
            allUniqueKeys.map(async (key) => {
              const fullKey = `separatorTestSteps${key}`; // Concatenate at start
              const capitalizedKey = fullKey.charAt(0) + fullKey.slice(1);
              const { displayName, digits } = await getDisplayName("separatortests", capitalizedKey);
              displayNames.push(displayName);
              digitsArray.push(digits);
            })
          );
          this.headers = Array.from(allKeys).map((key, index) => {
            const uom = this.serverItems.find((item) => item[key + "_UOM"]);
            const name = displayNames[index]; // Use display name instead of key
            let unit = uom ? uom[key + "_UOM"] : '-';
            if (!unit || unit === "data-not-available") {
              unit = "-";
            }
            const digits = digitsArray[index] || 0;
            return {
              key: key,
              name: name,
              unit: unit,
              digits: digits,
            };
          });

          return response.data.data.separatortest;
        } else if (response && response.data && response.data.message) {
          this.timeoutMessage = response.data.message;
        } else {
          this.timeoutMessage = "Error in fetching data";
        }
      } catch (error) {
        this.timeoutMessage = error;
        this.sendDataToParent();
      } finally {
        this.loading = false;
        this.showLoaders = false;
      }
    },

    async plotChartForVariable(variable, chartIndex, separatortest) {
      if (!separatortest || !separatortest.separatorTestSteps) {
        return;
      }

      const header = this.headers.find(header => header.key === variable);
      const digits = header ? header.digits : 0;

      const stepPressureHeader = this.headers.find(header => header.key === 'stepPressure');
      const stepPressureDigits = stepPressureHeader ? stepPressureHeader.digits : 0;

      const filteredData = separatortest.separatorTestSteps
        .filter(step => step.stepPressure !== undefined && step.stepPressure !== null && step[variable] !== undefined && step[variable] !== null)
        .map(step => ({
          x: step.stepPressure,
          y: step[variable],
        }));

      const axisType = this.yAxisScales[variable] || "linear";
      const yValues = filteredData.map((data) => {
        const numericValue = Number(data.y);
        if (!Number.isFinite(numericValue)) {
          return null;
        }
        if (axisType === "log" && numericValue <= 0) {
          return null;
        }
        return numericValue;
      });

      const trace = {
        x: filteredData.map(data => data.x),
        y: yValues,
        type: "scatter",
        mode: "lines+markers",
        name: variable,
        line: {
          color: "#2199A8",
          width: 2
        },
        marker: {
          color: "#2199A8",
          size: 8,
          line: {
            color: "#2199A8",
            width: 1
          }
        },
        connectgaps: false,
        hovertemplate: `%{x}<br>%{y:.${digits}f}<extra></extra>`,
      };

      const headerMeta = this.headers.find((item) => item.key === variable);

      const layout = {
        xaxis: {
          title: "Pressure (psia)",
          gridcolor: chartGridColor(this.isDarkMode),
        },
        yaxis: buildSimpleScatterLogYAxisConfig(axisType, {
          title: headerMeta
            ? buildVerticalYAxisTitle(headerMeta.name, headerMeta.unit)
            : { text: variable, standoff: 20 },
          gridcolor: chartGridColor(this.isDarkMode),
          yValues,
        }),
        margin: {
          l: 50,
          r: 0,
          b: 120,
        },
      };
      const config = {
        responsive: true,
        displaylogo: false,
        displayModeBar: true,
        modeBarButtonsToRemove: ['lasso2d', 'select2d', 'pan2d', "resetscale", "zoom", "toImage"],
        modeBarButtonsToAdd: [
          {
            name: "Expand",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${Expand}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.openModal.bind(this, chartIndex),
          },
          {
            name: 'Download CSV',
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${downloadIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadCSV.bind(this, chartIndex)
          },
          {
            name: "Download plot as a png",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${camIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadPNG.bind(this, chartIndex),
          },
        ]
      };

      this.chartData[chartIndex] = {
        trace: trace,
        layout: layout,
        config: config,
      };

      const chartRef = this.$refs["chart-" + chartIndex];
      if (chartRef && chartRef.length > 0) {
        const chartElement = chartRef[0];
        Plotly.newPlot(chartElement, [trace], layout, config);
      } else {
        return;
      }
    },

    getHeaderDisplayName(variable) {
      const header = this.headers.find((item) => item.key === variable);
      if (header) {
        return header.unit !== "-" ? `${header.name} (${header.unit})` : header.name;
      }
      return variable;
    },
    getHeaderDisplayNameChartTitle(variable) {
      const header = this.headers.find((item) => item.key === variable);
      if (header) {
        return header.name;
      }
      return variable;
    },
    getChartTitle(variable) {
      return `${this.getHeaderDisplayNameChartTitle(variable)} vs Pressure`;
    },

    handleDownloadCSV(chartIndex) {
      this.downloadChartCSV(chartIndex);
    },

    handleDownloadPNG(chartIndex) {
      this.downloadChartPNG(chartIndex);
    },

    downloadChartPNG(index) {
      const chartElement = this.$refs[`chart-${index}`];
      if (!chartElement?.[0]) return;
      const chartData = this.chartData[index];
      const variable = this.variables[index];
      const fileName = chartData
        ? `${this.getHeaderDisplayName(variable)} vs ${typeof chartData.layout.xaxis.title === "string" ? chartData.layout.xaxis.title : chartData.layout.xaxis.title?.text || "Pressure (psia)"}`
        : `Chart ${index}`;
      downloadPlotlyAsPng([chartData.trace], chartData.layout, fileName, {
        isDarkMode: this.isDarkMode,
        title: fileName,
      });
    },

    displayValue(key, value) {
      const header = this.headers.find(header => header.key === key);
      const digits = header ? header.digits : 0; // Get digits from header

      if (value !== null && value !== undefined) {
        if (typeof value === 'string') {
          return value;
        } else {
          const numValue = Number(value);
          if (!isNaN(numValue)) {
            return digits > 0 ? numValue.toFixed(digits) : value;
          }
        }
      } else {
        return "-";
      }
    },

    openModal(index) {
      this.isPreviewOpen[index] = true;
      this.$nextTick(() => {
        this.plotModalChart(index);
      });
    },

    closeModal(index) {
      this.isPreviewOpen[index] = false;
    },
    plotModalChart(index) {
      const chartData = this.chartData[index];
      if (chartData) {
        const modalChartRef = this.$refs[`modal-chart-${index}`][0];
        const axisType = this.modalYAxisScales[index] || "linear";
        const modalTrace = {
          ...chartData.trace,
          y: chartData.trace.y.map((value) => {
            const numericValue = Number(value);
            if (!Number.isFinite(numericValue)) {
              return null;
            }
            if (axisType === "log" && numericValue <= 0) {
              return null;
            }
            return numericValue;
          }),
          connectgaps: false,
        };
        const modalLayout = applyScatterModalYAxisScale(chartData.layout, axisType, modalTrace.y);

        Plotly.Plots.resize(modalChartRef);
        Plotly.newPlot(
          modalChartRef,
          [modalTrace],
          modalLayout,
          chartData.config
        );
      }
    },
    async sendDataToParent() {
      const rawHdr = this.sepTestHeaders || [];
      const sortOrder = await getSortOrder("separatortests", "separatorTest", "header");
      const headerData = [];

      for (const header of rawHdr) {
        if (!header || !header.key) continue;

        let value = header.value || "-";

        const capKey = header.key.charAt(0) + header.key.slice(1);
        let displayName, digits;
        try {
          const result = await getDisplayName("separatortests", capKey);
          displayName = result.displayName;
          digits = result.digits;
        } catch (e) {
          displayName = undefined;
          digits = undefined;
        }

        if (!displayName) {
          displayName = header.key;
        }

        headerData.push({
          originalKey: header.key,
          value: value,
          displayName: displayName,
          digits: digits ? digits : 0,
          unit: "", // Unit is now part of the value string
        });
      }

      this.$emit("data-updated", {
        sepTestProperties: headerData,
        sortOrder,
        originalData: rawHdr,
      });
    },
  },
  watch: {
    $route(to, from) {
      this.loadItems()
        .then((separatortest) => {
          this.variables.forEach((variable, index) => {
            this.plotChartForVariable(variable, index, separatortest);
          });
        })
        .catch((error) => {
          console.error("Error loading data:", error);
        });
    },

    isDarkMode() {
      this.loadItems().then((separatortest) => {
        this.variables.forEach((variable, index) => {
          this.plotChartForVariable(variable, index, separatortest);
        });
      });
    }
  },
  mounted() {
    this.loadItems().then(separatortest => {
      this.variables.forEach((variable, index) => {
        this.sendDataToParent()
        this.isYLog[variable] = false;
        this.isModalYLog[index] = false;
        this.plotChartForVariable(variable, index, separatortest);
      });
    });
  },
};
</script>